import React from 'react';

import BaseSessionNav from 'components/BaseSessionNav';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect } from 'omni-common-ui';
import { actions as UiState } from 'data/UiState';

class ProgressReportSessionNav extends BaseSessionNav {
  _hasNext() {
    return this.props.currentProgressReportIndex < this.props.progressReportCount - 1;
  }

  _hasPrevious() {
    return this.props.currentProgressReportIndex > 0;
  }

  _hasNextUnit() {
    return this.props.currentUnitIndex < this.props.unitCount - 1;
  }

  _hasPreviousUnit() {
    return this.props.currentUnitIndex > 0;
  }

  _getNextUnitText() {
    return this.props.nextUnitName;
  }

  _getPreviousUnitText() {
    return this.props.previousUnitName;
  }

  _getHeadingText() {
    return this.props.currentGroupName;
  }

  _getAdditionalChildren() {
    const { currentProgressReportName, currentUnitName } = this.props;
    return <h2>
      {`${currentProgressReportName}, ${currentUnitName}`}
    </h2>;
  }

  render() {
    if (is.existy(this.props.currentGroupName) && this.props.currentProgressReportName) {
      return super.render();
    }
    return null;
  }
}

ProgressReportSessionNav.propTypes = Object.assign({
  previousUnitName: PropTypes.string,
  nextUnitName: PropTypes.string,
  currentGroupName: PropTypes.string,
  currentUnitName: PropTypes.string,
  currentUnitIndex: PropTypes.number,
  currentProgressReportIndex: PropTypes.number.isRequired,
  currentProgressReportName: PropTypes.string.isRequired,
  progressReportCount: PropTypes.number.isRequired,
  unitCount: PropTypes.number,
}, BaseSessionNav.propTypes);

function mapStateToProps(state, ownProps) {
  const { groupId, progressReportId } = ownProps.params;
  if (! progressReportId) return;
  const group = state.get('rootReducer').get('groups').get(groupId) &&
    state.get('rootReducer').get('groups').get(groupId).data;
  const progressReports = group && group.get('progressReports') &&
    group.get('progressReports').data;

  if (group && progressReports) {
    const progressReport = progressReports.get(progressReportId);
    const previousPR = progressReports.find(
      (pr) => pr.index === progressReport.index - 1
    );
    const nextPR = progressReports.find(
      (pr) => pr.index === progressReport.index + 1
    );
    const currentUnitName = progressReport.units
      .map((unit) => unit.get('name'))
      .reduce((unitName, nextUnitName) => `${unitName} & ${nextUnitName}`);
    return {
      currentGroupName: group.name,
      currentProgressReportName: progressReport.name,
      currentUnitName,
      progressReportCount: progressReports.size,
      currentProgressReportIndex: progressReport.index,
      previousSessionLinkHref: previousPR && ownProps.buildRoute({
        progressReportId: previousPR.id,
        mode: '',
      }),
      nextSessionLinkHref: nextPR && ownProps.buildRoute({
        progressReportId: nextPR.id,
        mode: '',
      }),
      isHide: ! UiState.getShowNavigationBar(state),
    };
  }
}

export default connect(mapStateToProps, null)(ProgressReportSessionNav);



// WEBPACK FOOTER //
// ./components/ProgressReportSessionNav/index.jsx